import React, { useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import API from '../utils/api';
import toast from 'react-hot-toast';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { useSiteSettings } from '../context/SiteSettingsContext';
import useSEO from '../hooks/useSEO';
import './AuthPage.css';

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const { settings } = useSiteSettings();
  const sn = settings.siteName;
  useSEO({ title: 'Reset Sandi', siteName: sn, noindex: true });
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('Kata sandi minimal 6 karakter.'); return; }
    if (form.password !== form.confirm) { toast.error('Konfirmasi kata sandi tidak cocok.'); return; }
    setLoading(true);
    try {
      await API.post(`/auth/reset-password/${token}`, { password: form.password });
      toast.success('Kata sandi berhasil direset. Silakan masuk.');
      navigate('/login', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Token tidak valid atau sudah kedaluwarsa.');
    } finally { setLoading(false); }
  };

  return (
    <div className="auth-root">
      <div className="auth-body">
        <div className="auth-card">
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <h1 className="auth-title">{sn}</h1>
            <p className="auth-subtitle">Buat kata sandi baru</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Kata Sandi Baru</label>
              <div className="input-icon-wrap">
                <Lock size={15} className="input-icon" />
                <input type={showPw ? 'text' : 'password'} className="form-input input-with-icon input-with-action"
                  value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
                  placeholder="Minimal 6 karakter" required autoFocus />
                <button type="button" className="input-action" onClick={() => setShowPw(!showPw)}>
                  {showPw ? <EyeOff size={15} /> : <Eye size={15} />}
                </button>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Konfirmasi Kata Sandi</label>
              <div className="input-icon-wrap">
                <Lock size={15} className="input-icon" />
                <input type={showPw ? 'text' : 'password'} className="form-input input-with-icon"
                  value={form.confirm} onChange={e => setForm({ ...form, confirm: e.target.value })}
                  placeholder="Ulangi kata sandi" required />
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
              {loading ? 'Menyimpan...' : 'Simpan Kata Sandi Baru'}
            </button>
          </form>
          <p className="auth-footer-text" style={{ marginTop: 18 }}>
            <Link to="/login" className="auth-link">Kembali ke Masuk</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
